import DonutsUsageInmarsat from "../Donuts/DonutsUsageInmarsat";

const CreditLimitCard = ({ data, msg }) => {
	const InfoField = ({ label, children }) => (
		<div className="text-start">
			<p className="text-[10px] text-slate-400 sm:text-xs">{label}</p>
			<div className="mt-1 text-[10px] text-slate-100 sm:text-xs">{children}</div>
		</div>
	);

	const ExtensionSection = ({}) => (
		<div className="mb-4 text-start">
			<p className="font-medium text-slate-100 text-xs sm:text-sm">Extension(s)</p>
		</div>
	);

	return (
		<div className="overflow-hidden rounded-xl bg-[#171a35] shadow-lg ring-1 ring-white/5">
			<div className="flex items-center justify-between gap-2 border-slate-700 border-b px-5 py-4">
				<h1 className="text-start font-semibold text-slate-100 text-xs tracking-wide sm:text-sm">
					Credit Limit
				</h1>
			</div>
			<div className="p-4">
				<div className="mb-2 grid grid-cols-1 gap-2 md:grid-cols-2">
					<DonutsUsageInmarsat
						allowance={data?.allowanceValue}
						totalUsage={data?.allowanceCurrentValue}
						unity="$"
						message="Consumption usage"
						alerts={[]}
						AllowanceValueName={"Allowance Value"}
						AllowanceCurrentValueName={"Allowance Current Value"}
					/>
					<DonutsUsageInmarsat
						allowance={data?.limitValue}
						totalUsage={data?.limitCurrentValue}
						unity="$"
						message="Consumption usage"
						alerts={[]}
						AllowanceValueName={"Limit Value"}
						AllowanceCurrentValueName={"Limit Current Value"}
					/>
				</div>
				{/* <div className="mb-4 rounded-lg border border-white/5 bg-white/[0.02] p-2">
					<div className="grid grid-cols-2 gap-y-4">
						<InfoField label="Allowance Value">{data?.allowanceValue} GB</InfoField>
						<InfoField label="Allowance Current Value">{data?.allowanceCurrentValue} GB</InfoField>
						<InfoField label="Limit Value">{data?.limitValue} GB</InfoField>
						<InfoField label="Limit Current Value">{data?.limitCurrentValue} GB</InfoField>
					</div>
				</div> */}
				<ExtensionSection />
				<div className="rounded-lg border border-white/5 bg-white/[0.02] p-2">
					<div className="grid grid-cols-2 gap-y-4">
						<InfoField label="Cycle Duration">{data?.cycleDuration}</InfoField>
						<InfoField label="Next Replenish Date">{data?.nextReplenishDate}</InfoField>
						<InfoField label="50% Threshold In Bundle">
							{data?.threshold50PercentInBundle || "Not Yet"}
						</InfoField>
						<InfoField label="100% Disconnect Out of Bundle">
							{data?.disconnect100PercentOutOfBundle || "Not Yet"}
						</InfoField>
					</div>
				</div>
			</div>
		</div>
	);
};
export default CreditLimitCard;
